import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '@/components/auth/PrivateRoute';
import { MENU } from '@/constants/menuCodes';

const InventoryItemPage = lazy(() => import('@/pages/inventory/InventoryItemPage'));
const InventoryHistoryPage = lazy(() => import('@/pages/inventory/InventoryHistoryPage'));
const InventoryStatusPage = lazy(() => import('@/pages/inventory/InventoryStatusPage'));
const InventoryMonthlyClosingPage = lazy(() => import('@/pages/inventory/InventoryMonthlyClosingPage'));
const InventoryByLocationPage = lazy(() => import('@/pages/inventory/InventoryByLocationPage'));
const InventoryCountPage = lazy(() => import('@/pages/inventory/InventoryCountPage'));
const InventoryRentalPage = lazy(() => import('@/pages/inventory/InventoryRentalPage'));

/** 재고관리 모듈 라우트 */
const inventoryRoutes = [
  <Route
    key="inventory-items"
    path="inventory/items"
    element={<PrivateRoute menuCode={MENU.INV_ITEM}><InventoryItemPage /></PrivateRoute>}
  />,
  <Route
    key="inventory-status"
    path="inventory/status"
    element={<PrivateRoute menuCode={MENU.INV_INOUT}><InventoryHistoryPage /></PrivateRoute>}
  />,
  <Route
    key="inventory-stock-status"
    path="inventory/stock-status"
    element={<PrivateRoute menuCode={MENU.INV_STOCK}><InventoryStatusPage /></PrivateRoute>}
  />,
  <Route
    key="inventory-monthly-closing"
    path="inventory/monthly-closing"
    element={<PrivateRoute menuCode={MENU.INV_MONTHLY_CLOSING}><InventoryMonthlyClosingPage /></PrivateRoute>}
  />,
  <Route
    key="inventory-by-location"
    path="inventory/by-location"
    element={<PrivateRoute menuCode={MENU.INV_LOCATION}><InventoryByLocationPage /></PrivateRoute>}
  />,
  <Route
    key="inventory-count"
    path="inventory/count"
    element={<PrivateRoute menuCode={MENU.INV_COUNT}><InventoryCountPage /></PrivateRoute>}
  />,
  <Route
    key="inventory-rentals"
    path="inventory/rentals"
    element={<PrivateRoute menuCode={MENU.INV_RENTAL}><InventoryRentalPage /></PrivateRoute>}
  />,
];

export default inventoryRoutes;
